import * as types from './mutation-types'

export const islamicFormData = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    window.axios.get('/api/islamicFinanceForms').then((response) => {
      commit(types.BOOTSTRAP_FORMS, response.data.forms.data)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const UpdateIslamicFormData = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.put(`/api/islamicFinanceForms/${data.id}`, data).then((response) => {
      if (response.data) {
        commit(types.UPDATE_FORM, response.data.form)
      }
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
